import { Service, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Service()
/**
 * Shared Behavior Subjects For Use Within Org Settings => Home
 */
export class OrgHomeService {
  private translate = inject(TranslateService);

  public i18n = this.translate.instant([
    'Core_DiscardChanges',
    'Core_GeneralErrorMessage',
  ]);

  // Private BehaviorSubjects
  private isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  private dynamicSkillPlanEnabled: BehaviorSubject<boolean | undefined> =
    new BehaviorSubject<boolean | undefined>(undefined);
  private layoutConfigRefresh = new Subject<void>();

  // Public Observables
  public isLoading$: Observable<boolean> = this.isLoading.asObservable();
  public dynamicSkillPlanEnabled$: Observable<boolean | undefined> =
    this.dynamicSkillPlanEnabled.asObservable();
  public layoutConfigRefresh$: Observable<void> =
    this.layoutConfigRefresh.asObservable();

  /**
   * Determines whether or not a spinner should display on the page
   * @param isLoading boolean
   */
  public setIsLoading(isLoading: boolean) {
    this.isLoading.next(isLoading);
  }

  /**
   * Sets the dynamicSkillPlanEnabled BehaviorSubject
   * @param isEnabled boolean
   */
  public setDynamicSkillPlanEnabled(isEnabled: boolean): void {
    this.dynamicSkillPlanEnabled.next(isEnabled);
  }

  /**
   * Triggers a refetch of the home page layout configuration
   */
  public triggerLayoutConfigRefresh(): void {
    this.layoutConfigRefresh.next();
  }

  /**
   * Gets the current value of dynamicSkillPlanEnabled
   * @returns boolean | undefined
   */
  public getDynamicSkillPlanEnabled(): boolean | undefined {
    return this.dynamicSkillPlanEnabled.value;
  }
}
